module.exports = __webpack_public_path__ + "img/root010.dcaef4af.png";